import React, { Fragment } from 'react';
import approx from 'approximate-number';
import { distanceInWordsToNow } from 'date-fns';
import PropTypes from 'prop-types';
import { Row } from 'components/Grid';
import { convertToLocalDate } from '../../utils/helper';

const styles = {
  bottomMargin: {
    marginBottom: 16,
  },
  label: {
    fontWeight: '600',
  },
  list: { padding: 0 },
  listItemInnerDiv: { padding: '8px 16px' },
  card: {},
};

const CommunityMeta = ({ children, community, viewer }) => {
  return (
    <Fragment>
      {children}
      <Row inner style={styles.bottomMargin}>
        <h5>Stats</h5>
      </Row>
      {viewer?.loggedIn && community?.memberSince && (
        <Fragment>
          <Row innerBig style={styles.label}>
            Joined Community
          </Row>
          <Row innerBig style={styles.bottomMargin}>
            {distanceInWordsToNow(convertToLocalDate(community?.memberSince))}{' '}
            ago
          </Row>
        </Fragment>
      )}
      {viewer?.loggedIn && community?.stats?.participantCount > 0 && (
        <Fragment>
          <Row innerBig style={styles.label}>
            Events Participated
          </Row>
          <Row innerBig style={styles.bottomMargin}>
            {approx(community?.stats?.participantCount)}
          </Row>
        </Fragment>
      )}
      {community?.stats?.discussionCount > 0 && (
        <Fragment>
          <Row innerBig style={styles.label}>
            Discussions
          </Row>
          <Row innerBig style={styles.bottomMargin}>
            {approx(community?.stats?.discussionCount)}
          </Row>
        </Fragment>
      )}
      {community?.stats?.imageCount > 0 && (
        <Fragment>
          <Row innerBig style={styles.label}>
            Photos
          </Row>
          <Row innerBig style={styles.bottomMargin}>
            {approx(community?.stats?.imageCount)}
          </Row>
        </Fragment>
      )}
      {community?.stats?.videoCount > 0 && (
        <Fragment>
          <Row innerBig style={styles.label}>
            Videos
          </Row>
          <Row innerBig style={styles.bottomMargin}>
            {approx(community?.stats?.videoCount)}
          </Row>
        </Fragment>
      )}
      {community?.stats?.reviewCount > 0 && (
        <Fragment>
          <Row innerBig style={styles.label}>
            Reviews
          </Row>
          <Row innerBig style={styles.bottomMargin}>
            {approx(community?.stats?.reviewCount)}
          </Row>
        </Fragment>
      )}
      {community?.personCount > 0 && (
        <Fragment>
          <Row innerBig style={styles.label}>
            Members
          </Row>
          <Row innerBig style={styles.bottomMargin}>
            {approx(community?.personCount)}
          </Row>
        </Fragment>
      )}
    </Fragment>
  );
};

CommunityMeta.propTypes = {
  children: PropTypes.node,
  community: PropTypes.object.isRequired,
  relay: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
};

export default CommunityMeta;
